import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'src/hooks/useAuth';
import { ValidationMessages } from 'src/components/common/ValidationMessage';
import CustomLoader from 'src/components/common/CustomLoader';

export default function LoginForm() {
  const navigate = useNavigate();
  const {
    loading,
    login,
    user,
    validationMessages,
    setValidationMessages 
  } = useAuth();

  const [formData, setFormData] = useState({
    login_id: '',
    password: '',
    autoLogin: false,
  });

  const currentDate = new Date();
  const formattedDate = currentDate.toISOString().split('T')[0];

  // Handle Input Changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Form Submit Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    await login(formData.login_id, formData.password, formData.autoLogin);
  };

  useEffect(() => {
    if (user) {
      navigate(`/scheduleList/${formattedDate}`);
    }
  }, [user, navigate]);

  if (loading) return <CustomLoader />;
  return (
    <section
      className="container"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#fff',
      }}
    >
      <form
        className="form-horizontal"
        onSubmit={handleSubmit}
        style={{ width: '100%', maxWidth: '400px', padding: '20px' }}
      >
        {/* Validation Messages */}
        {validationMessages && validationMessages.length > 0 && (
                <div style={{ background: "#ffe4e2" }}>
                    <ValidationMessages
                      messages={validationMessages}
                      onClose={() => setValidationMessages([])}
                    />
                </div>
              )}

        {/* Logo */}
        <h1
          className="logo"
          style={{ display: 'block', width: 'auto', lineHeight: '58px', margin: '0 0 30px' }}
        >
          DAILY WORK SYSTEM
        </h1>

        {/* Input Fields */}
        <div className="form-group">
          <input
            type="text"
            name="login_id"
            placeholder="ID"
            className="form-control"
            value={formData.login_id}
            onChange={handleChange}
          />
        </div>
        <div className="form-group">
          <input
            type="password"
            name="password"
            placeholder="PASS"
            className="form-control"
            value={formData.password}
            onChange={handleChange}
          />
        </div>

        {/* Submit Button */}
        <div className="form-group">
          <button type="submit" className="jq_login btn btn-success btn-lg btn-block">
            LOGIN
          </button>
          <div className="ac">
            <label htmlFor="save_id">
              <input
                type="checkbox"
                name="autoLogin"
                id="save_id"
                checked={formData.autoLogin}
                onChange={handleChange}
              />
              Auto Login
            </label>
          </div>
        </div>
      </form>
    </section>
  );
}
